module.exports = __webpack_public_path__ + "img/Capture2.c3542817.gif";